import { sendInitEventToGTM } from '@sbt-web/tracking';
import { loadAsync } from '@sbt-web/utils';
import { GTM_URL } from '@/shared/constants';

async function loadGTM(): Promise<void> {
  sendInitEventToGTM();
  await loadAsync({ url: GTM_URL });
}
export { loadGTM };
